// Zero resolves after the first paint, so the accent starts from the last one
// this browser saw and the icons never flash an unset colour.
const CACHE_KEY = "pl-accent-color"

export const DEFAULT_ACCENT_COLOR = {
	light: "#18BDCC",
	dark: "#26B5CE",
} as const

export type AccentMode = keyof typeof DEFAULT_ACCENT_COLOR

const HEX = /^#[0-9a-f]{3,8}$/i

export function readCachedAccentColor(mode: AccentMode): string | null {
	if (typeof localStorage === "undefined") return null
	try {
		const cached = localStorage.getItem(`${CACHE_KEY}-${mode}`)
		return cached && HEX.test(cached) ? cached : null
	} catch {
		return null
	}
}

export function cacheAccentColor(mode: AccentMode, color: string) {
	if (typeof localStorage === "undefined") return
	try {
		localStorage.setItem(`${CACHE_KEY}-${mode}`, color)
	} catch {
		// A full or blocked store just costs us the head start.
	}
}

export function resolveAccentColor({
	mode,
	loaded,
	cached,
}: {
	mode: AccentMode
	loaded?: string | null
	cached?: string | null
}) {
	return loaded ?? cached ?? DEFAULT_ACCENT_COLOR[mode]
}
